<template>
  <div>
    <div v-if="!showForm"> 
      <div class="text-left p-3">
        <button @click="openFormAdmin" class="btn btn-prv-outline">Add New Admin</button>
      </div>
      <div>
        <div :key="index" v-for="(admin, index) in admins">
          <admin-card :key="check"
            v-bind:admin="admin"
            v-bind:adminActions="admin_actions"
            v-on:save-admin="getAdmins"
          ></admin-card>
        </div>
      </div>
    </div>
    <div v-else>
      <admin-add
        :key="check"
        v-bind:adminActions="admin_actions"
        v-on:close-form="closeFormAdmin"
      ></admin-add>
    </div>
    <v-snackbar :color="bgColor" :timeout="timeOut" top v-model="adminAdded">
      <div style="text-align: center; width: 100%">
        <span style="padding-right: 1rem"
          ><v-icon color="#fff">{{ snackIcon }}</v-icon></span
        >{{ snackMessage }}
      </div>
    </v-snackbar>

    <v-snackbar :color="bgColor" :timeout="timeOut" top v-model="permissionAdded">
      <div style="text-align: center; width: 100%">
        <span style="padding-right: 1rem"
          ><v-icon color="#fff">{{ snackIcon }}</v-icon></span
        >{{ snackMessage }}
      </div>
    </v-snackbar>
  </div>
</template>

<script>
    import {GET_ALL_ADMINS} from "../../../Api/admin_api";
    import AdminCard from "./admin-card";
    import AdminAdd from "./admin-add";
    export default {
        name: "main",
        components: {
            AdminCard,
            AdminAdd
        },
        data: function () {
            return {
                timeOut: 1000,
                bgColor: "#454545",
                snackbar: false,
                snackMessage: "",
                snackIcon: "",
                admins: [],
                admin_actions: {},
                check: 0,
                showForm: false,
                adminAdded:false,
                permissionAdded: false,

            }
        },
        methods: {
            openFormAdmin(){
              const self = this;
              self.showForm = true;
            },
            closeFormAdmin(val){
                const self = this;
                self.showForm = false;
                if(!!val){
                  this.adminAdded=true
                  this.snackIcon = self.$constants.SNACKBAR_ICON.SUCCESS;
                  this.bgColor = self.$constants.SNACKBAR_COLOR.SUCCESS;
                  this.snackMessage = val;
                };
            },
            getAdmins(val){
                const self = this;
                GET_ALL_ADMINS().then(function (resp) {
                    self.admins = resp.data.users;
                    self.admin_actions = resp.data.actions
                    self.check++;
                }).catch(function () {
                });
                if(!!val){
                  this.permissionAdded=true
                  this.snackIcon = self.$constants.SNACKBAR_ICON.SUCCESS;
                  this.bgColor = self.$constants.SNACKBAR_COLOR.SUCCESS;
                  this.snackMessage = val;
                };
            }
        },
        mounted(){
            const self = this;
            self.getAdmins();
        }
    }
</script>

<style scoped>

</style>